module.exports = __webpack_public_path__ + "img/绿@3x.683af9c6.png";